import {omit, orderBy} from 'lodash'
import React from 'react'
import Text from 'react-text'
import Select from 'react-select'
import {Consumer} from '../../../../context'

function SelectFilter(props) {
  const className = `select-${props.name}`
  const selectProps = omit(props, ['name'])
    return (
      <div className={className}>
        <div className="dropdown">
          <Select
            {...selectProps}
            className={className}
            classNamePrefix="select"
            isSearchable = {false}
            isClearable = {true}
            escapeClearsValue = {true}
            getOptionValue = {({id}) => id}
            value = {props.value}
          />
        </div>
      </div>
    )
}

function onGroup(context) {
  return option => {
    const {id} = option || {}
    const query = {page: undefined, unit: undefined, lesson: undefined}
    context.navigate({groupId: id}, '/:languageId/:role/monitoring/:groupId?/students', {preserveQuery: true, query})
  }
}

function onUnit(context) {
  return option => {
    const {id: unit} = option || {}
    const query = {unit, page: undefined, lesson: undefined}
    context.navigate({}, context.match.path, {preserveQuery: true, query})
  }
}

function onLesson(context) {
  return option => {
    const {id: lesson} = option || {}
    const query = {lesson, page: undefined}
    context.navigate({}, context.match.path, {preserveQuery: true, query})
  }
}

export default function Filters () {
  return (<Consumer>{ context => {
    const placeholder = name => context.translate(`${name}_filters_placeholder`)
    const {downloadLogFilters: groups = []} = context 
    const group = groups.find(group => group.id == context.groupId)
    const units = group ? orderBy(group.units, ['id']) : []
    const unit = units.find(unit => unit.id == context.query.unit)
    const lessons = unit ? orderBy(unit.lessons, ['id']) : []
    const lesson = lessons.find(lesson => lesson.id == context.query.lesson)
    return (
      <div className="select-filters">
        <div className="group filter">
          <div className="label">
            <Text id="group_label" />:
          </div>
          <SelectFilter
            name="group"
            options={groups}
            value={group || null}
            getOptionLabel={item => item.name}
            onChange={onGroup(context)}
          />
        </div>
        <div className="unit filter">
          <div className="label">
            <Text id="unit_label" />:
          </div>
          <SelectFilter
            name="unit"
            options={units}
            value={unit || null}
            getOptionLabel={item => `${item.id.substring(8,10)} - ${item.name}`}
            onChange={onUnit(context)}
          />
        </div>
        <div className="lesson filter">
          <div className="label">
            <Text id="lesson_label" />:
          </div>
          <SelectFilter
            name="lesson"
            options={lessons}
            value={lesson || null}
            getOptionLabel={item => `${item.id.substring(11,13)} - ${item.name}`}
            onChange={onLesson(context)}
          />
        </div>
      </div>
    )
  }}</Consumer>)
}

